import logger from '../utils/rbata.logger';

const orderHistory = {
    giftCardCode: undefined,

    init() {
        this.giftCardCode = $('.order-detail__gc-code-copy');
    },

    bindEvents() {
        this.giftCardCode.on('click', this.copyGcCodeToClipboad)
    },

    copyGcCodeToClipboad(evt) {
        const gcCode = $(evt.currentTarget).data('gc-code');
        navigator.clipboard.writeText(gcCode);
        logger.log(`Copied gc code to clipbard: ${gcCode}`);
    }
}

$(() => {
    orderHistory.init();
    orderHistory.bindEvents();
});

export default orderHistory;